var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraphicLogo4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 119,
    viewBox: "0 0 120 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6025_930)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.2899 108.65C100.835 108.65 116.68 92.8055 116.68 73.2601C116.68 53.7148 100.835 37.8701 81.2899 37.8701C61.7445 37.8701 45.8999 53.7148 45.8999 73.2601C45.8999 92.8055 61.7445 108.65 81.2899 108.65Z",
    fill: "#00A5D5"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.84 64.5201C71.0712 64.5201 85.04 50.5514 85.04 33.3201C85.04 16.0888 71.0712 2.12012 53.84 2.12012C36.6087 2.12012 22.64 16.0888 22.64 33.3201C22.64 50.5514 36.6087 64.5201 53.84 64.5201Z",
    fill: "#FF009D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1499 95.6702C44.4935 95.6702 54.4999 85.6638 54.4999 73.3202C54.4999 60.9767 44.4935 50.9702 32.1499 50.9702C19.8064 50.9702 9.79993 60.9767 9.79993 73.3202C9.79993 85.6638 19.8064 95.6702 32.1499 95.6702Z",
    fill: "#FFDF00"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M118.12 32.0799V1.41992H86.7999",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.42993 87.6201V118.29H32.7499",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1499 118.37H118.81V87.0498",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.61 1.67969H1.94995V32.9997",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7799 75.05C38.7799 75.05 58.5899 94.82 82.4499 74.98",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M48.52 34.0498V44.7598",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M72.96 34.0498V44.7598",
    stroke: "black",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6025_930"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 118.38,
    height: 117.95,
    fill: "white",
    transform: "translate(0.929932 0.919922)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphicLogo4);
export default __webpack_public_path__ + "static/media/graphic-logo-4.12fcfeacd588e7690a7e0064fae3d3e3.svg";
export { ForwardRef as ReactComponent };